import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LayoutService } from '../core/layout/layout.service';
import { AppIconsRegistry } from '../ui/icons/app-icons.registry';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import { FilterBarVisibilityService } from './filter-bar/filter-bar-route';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarDrawerComponent } from './sidebar-drawer/sidebar-drawer.component';
import { ShellChromeVisibilityService } from './shell-chrome-route';
import { SkipLinkComponent } from './skip-link/skip-link.component';
import { TopBarComponent } from './top-bar/top-bar.component';

/**
 * The persistent application frame (FR-001): skip link, sidebar (hidden in the
 * sm band), top bar, breadcrumb, the AITH-44 global filter bar, and the
 * <main id="content"> outlet region, plus the overlay drawer — every
 * conditional part hosted via @if (never CSS hiding).
 */
@Component({
  selector: 'app-shell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    SidebarComponent,
    SidebarDrawerComponent,
    SkipLinkComponent,
    TopBarComponent,
    FilterBarComponent,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class ShellComponent {
  // Eagerly register the shell's icon set (ui-standards.md §6).
  protected readonly icons = inject(AppIconsRegistry);
  protected readonly layout = inject(LayoutService);
  /** Default shown; sign-in and ** opt out via route data (R-011). */
  protected readonly filterBarVisible = inject(FilterBarVisibilityService).visible;
  /** Public routes render without workspace navigation or controls. */
  protected readonly shellChromeVisible = inject(ShellChromeVisibilityService).visible;
}
